<script setup>
import OutbreakTable from '@/views/quality/infection-control/outbreak/OutbreakTable.vue'

definePage({
  meta: {
    subject: 'quality.infection_control.menu',
    action: 'outbreak',
  },
})
</script>

<template>
  <section>
    <OutbreakTable />
  </section>
</template>
